export default __webpack_public_path__ + "static/media/roman_1.8dc20f45.svg";